import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import { withRouter } from "react-router-dom";
import { updateBranch, getSingleBranch } from "actions/company";
import PageHeader from "components/ui/page-header";
import { InlineWaiting } from "components/ui";
import BranchForm from "./branch-form";
import { getRouteParam } from "routes";

export class EditBranch extends Component {
  componentDidMount() {
    const { branch, getSingleBranch } = this.props;
    const companyId = getRouteParam(this.props, "id");
    const branchId = getRouteParam(this.props, "bid");

    // Fetch single branch data if not already loaded or if it's a different branch
    if (!branch || branch.id !== branchId) {
      getSingleBranch(companyId, branchId);
    }
  }

  componentDidUpdate(prevProps) {
    const { branch, getSingleBranch } = this.props;
    const companyId = getRouteParam(this.props, "id");
    const branchId = getRouteParam(this.props, "bid");
    const prevBranchId = getRouteParam(prevProps, "bid");

    // If branchId changed, fetch the new branch
    if (branchId !== prevBranchId) {
      getSingleBranch(companyId, branchId);
    }
  }

  editBranch = formValues => {
    const { updateBranch } = this.props;
    const companyId = getRouteParam(this.props, "id");
    const branchId = getRouteParam(this.props, "bid");
    return updateBranch({ companyId, branch: formValues, branchId });
  };

  render() {
    const { branch, isFetching } = this.props;
    const branchId = getRouteParam(this.props, "bid");

    // Check if the loaded branch matches the one we need
    const isBranchLoaded = branch && branch.id === branchId;

    return (
      <div>
        <PageHeader title={`Edit Branch ${isBranchLoaded ? branch.branch_name : ""}`} />
        {isFetching || !isBranchLoaded ? (
          <InlineWaiting reason="Loading branch..." />
        ) : (
          <BranchForm onSubmit={this.editBranch} initialValues={branch} />
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      branch: selectors.getSingleBranch(state),
      isFetching: selectors.getIsFetchingSingleBranch(state)
    }),
    { updateBranch, getSingleBranch }
  )(EditBranch)
);

EditBranch.propTypes = {
  branch: PropTypes.object,
  isFetching: PropTypes.bool,
  getSingleBranch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object
  }).isRequired,
  updateBranch: PropTypes.func.isRequired
};
